<section id="rcs">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Risk Capacity Survey Investment Policy Statement</h1>
      </div>
    </div>
  </div>
</section>

<div class="wrapper">
  @if (loading) {
    <div class="overlay">
      <div class="spinner-wrapper">
        <app-spinner></app-spinner>
      </div>
    </div>
  }

  <div class="printable">
    @if (results && results!=null) {
      <section class="section" id="printFinalResults">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <button (click)="printComponent('printFinalResults')">Print</button><br /><br />
              <strong class="allcapsAlt">Name: {{results.name}}</strong><br />
              <strong class="allcapsAlt">Email: {{results.email}}</strong><br />
              <strong class="allcapsAlt">Your Risk Capacity Score: {{results.totalScore}}</strong><br />
              <strong class="allcapsAlt">Your recommended Risk Exposure is {{results.totalScore}}% equity funds and {{(100 - results.totalScore)}}% fixed income funds.</strong><br />
              <strong class="allcapsAlt"><a [href]="results.portfolioUrlOnly | safe:'url'">Please click here to review the risk and return data for IFA Index Portfolio {{results.totalScore}}</a></strong><br />
              <hr>
                <div [innerHTML]="results.ipsIntroText | safe:'html'"></div>
                <div class="clearfix"></div>
                @for (c of results.categories; track c) {
                  <div>
                    <div class="categoryTitle" [innerHTML]="c.title | safe:'html'"></div>
                    <div class="categoryDescription" [innerHTML]="c.description | safe:'html'"></div>
                    @if(c.answers.length>0) {
                      @for(a of c.answers; track a) {
                        <div class="categoryAnswer" [innerHTML]="a.comment | safe:'html'"></div>
                      }
                      <!-- <div class="categoryAnswer" [innerHTML]="c.answers[0] | safe:'html'"></div> -->
                    }
                  </div>
                }
                <div class="clearfix"></div>
                <div [innerHTML]="results.ips2to9Text | safe:'html'"></div><br /><br />
                <button (click)="printComponent('printFinalResults')">Print</button><br /><br />
                <strong class="allcapsAlt">Your Risk Capacity Score: {{results.totalScore}}</strong><br />
                <strong class="allcapsAlt">Your recommended Risk Exposure is {{results.totalScore}}% equity funds and {{(100 - results.totalScore)}}% fixed income funds.</strong><br />
                <strong class="allcapsAlt"><a [href]="results.portfolioUrlOnly | safe:'url'">Please click here to review the risk and return data for IFA Index Portfolio {{results.totalScore}}</a></strong><br />
              </div>
            </div>
          </div>
        </section>
      }
    </div>